<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div class="bg-white padding-xl" style="position:relative;">
			<Form ref="formPageModify" :model="formPageModify" label-position="right" :label-width="100" label-colon>
				<FormItem label="页面名称" required>
					<Input v-model="formPageModify.name" :maxlength="16" placeholder="页面名称" style="width:300px;"></Input>
				</FormItem>
				<FormItem label="页面内容" required>
					<div ref="editorElem" style="text-align:left;"></div>
				</FormItem>
				<FormItem label="创建时间">
					<div style="text-align:left;">{{formPageModify.addtime}}</div>
				</FormItem>
				<FormItem label="最后更新">
					<div style="text-align:left;">{{formPageModify.updatetime}}</div>
				</FormItem>
				<FormItem label="浏览次数">
					<div style="text-align:left;">{{formPageModify.viewtimes}}</div>
				</FormItem>
				<Divider />
				<FormItem>
					<Button type="primary" @click="submitformPageModify('formPageModify')">提交</Button>
				</FormItem>
			</Form>
			<Spin fix v-if="loading">
				<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
				<div>处理中...</div>
			</Spin>
		</div>
	</div>
</template>

<script>
	import E from "wangeditor";
	export default {
		data() {
			return {
				id:'',
				loading: false,
				formPageModify: {
					name:'',
					content:''
				},
				editor: null
			};
		},
		methods: {
			loadinfo() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/client/page/modify.php?a=init',{id:this.id}).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.formPageModify = res.data.data.info;
							this.editor.txt.html(this.formPageModify.content)
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			submitformPageModify(name) {
				this.loading = true;
				this.$http.post('/server/api/client/page/modify.php?a=save',this.formPageModify).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.$Modal.success({
								title: '操作成功',
								content: '更新页面成功！',
								onOk:()=>{
									this.$router.back(-1)
								}
							});
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			//console.log(this.searchForm)
			this.id = this.$route.params.id;
			this.loadinfo();
		},
		mounted() {
			this.editor = new E(this.$refs.editorElem);
			this.editor.customConfig.onchange = html => {
				this.formPageModify.content = html;
			};
			this.editor.customConfig.menus = [
				// 菜单配置
				'head', // 标题
				'bold', // 粗体
				'fontSize', // 字号
				'fontName', // 字体
				'italic', // 斜体
				'underline', // 下划线
				'strikeThrough', // 删除线
				'foreColor', // 文字颜色
				'backColor', // 背景颜色
				'link', // 插入链接
				'list', // 列表
				'justify', // 对齐方式
				'quote', // 引用
				'emoticon', // 表情
				'image', // 插入图片
				'table', // 表格
				'code', // 插入代码
				'undo', // 撤销
				'redo' // 重复
			];
			this.editor.customConfig.debug = false;
			this.editor.customConfig.zIndex = 100;
			this.editor.customConfig.uploadImgServer = "/server/api/wangUpload.php?a=upload";
			this.editor.customConfig.uploadFileName = 'file';
			this.editor.customConfig.uploadImgParams = {
				dir: "image"
			};
			this.editor.customConfig.uploadImgMaxLength = 1;
			this.editor.customConfig.customAlert = (info) => {
				// info 是需要提示的内容
				this.$Message.error(info)
			};
			this.editor.create(); // 创建富文本实例
		}
	};
</script>

<style>
</style>
